export const getDisplayApy = (cakeRewardsApr?: number, lpRewardsApr?: number) => {
  if (!cakeRewardsApr) {
    return null
  }

  let apr
  if (cakeRewardsApr && lpRewardsApr) {
    apr = cakeRewardsApr + lpRewardsApr
  } else {
    apr = cakeRewardsApr
  }

  const APY_THRESHOLD = 10000000 

  const apy = ((1 + apr / 100 / 365) ** 365 - 1) * 100

  const cappedApy = !Number.isFinite(apy) || apy > APY_THRESHOLD ? APY_THRESHOLD : apy

  return cappedApy.toLocaleString('en-US', { maximumFractionDigits: 2 })
}
